/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetTunneledMcpServerMetricsRequest,
  GetTunneledMcpServerMetricsSecurity,
  Window,
} from "../models/operations/gettunneledmcpservermetrics.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildGetTunneledMcpServerMetricsQuery,
  GetTunneledMcpServerMetricsQueryData,
  prefetchGetTunneledMcpServerMetrics,
  queryKeyGetTunneledMcpServerMetrics,
} from "./getTunneledMcpServerMetrics.core.js";
export {
  buildGetTunneledMcpServerMetricsQuery,
  type GetTunneledMcpServerMetricsQueryData,
  prefetchGetTunneledMcpServerMetrics,
  queryKeyGetTunneledMcpServerMetrics,
};

export type GetTunneledMcpServerMetricsQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getServerMetrics tunneledMcp
 *
 * @remarks
 * Read seven-day payload-free tunnel activity aggregates
 */
export function useGetTunneledMcpServerMetrics(
  request: GetTunneledMcpServerMetricsRequest,
  security?: GetTunneledMcpServerMetricsSecurity | undefined,
  options?: QueryHookOptions<
    GetTunneledMcpServerMetricsQueryData,
    GetTunneledMcpServerMetricsQueryError
  >,
): UseQueryResult<
  GetTunneledMcpServerMetricsQueryData,
  GetTunneledMcpServerMetricsQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildGetTunneledMcpServerMetricsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getServerMetrics tunneledMcp
 *
 * @remarks
 * Read seven-day payload-free tunnel activity aggregates
 */
export function useGetTunneledMcpServerMetricsSuspense(
  request: GetTunneledMcpServerMetricsRequest,
  security?: GetTunneledMcpServerMetricsSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    GetTunneledMcpServerMetricsQueryData,
    GetTunneledMcpServerMetricsQueryError
  >,
): UseSuspenseQueryResult<
  GetTunneledMcpServerMetricsQueryData,
  GetTunneledMcpServerMetricsQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildGetTunneledMcpServerMetricsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setGetTunneledMcpServerMetricsData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      id: string;
      window?: Window | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: GetTunneledMcpServerMetricsQueryData,
): GetTunneledMcpServerMetricsQueryData | undefined {
  const key = queryKeyGetTunneledMcpServerMetrics(...queryKeyBase);

  return client.setQueryData<GetTunneledMcpServerMetricsQueryData>(key, data);
}

export function invalidateGetTunneledMcpServerMetrics(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      id: string;
      window?: Window | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "tunneledMcp",
      "getServerMetrics",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllGetTunneledMcpServerMetrics(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "tunneledMcp", "getServerMetrics"],
  });
}
